import { HttpClient } from '@angular/common/http';
import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppContextService } from '../services/app-context.service';
import { OperationResult } from '../models/server-result/operation-result';
import { Observable } from 'rxjs';
import {
	AggregateDocumentConfirmingFinancialRequest,
	FinancialMovementSearchCriteria,
	FinancialMovementResult,
} from '../models/financial-movement/financial-movement';

@Injectable()
export class ConfirmingPaymentsApiService {
	constructor(
		private http: HttpClient,
		private appContext: AppContextService,
		private domSanitizer: DomSanitizer
	) {}

	public getFinancialRequestByDocumentId(documentId: string): Observable<OperationResult<AggregateDocumentConfirmingFinancialRequest>> {
		return this.http.get<OperationResult<AggregateDocumentConfirmingFinancialRequest>>(
			this.domSanitizer.sanitize(
				SecurityContext.URL,
				this.appContext.getAPIUrl() + '/confirming/payments/financialrequest/document/' + documentId + '/aggregate'
			)!
		);
	}

	public searchFinancialMovements(criteria: FinancialMovementSearchCriteria): Observable<OperationResult<FinancialMovementResult[]>> {
		criteria.PageNumber -= 1;
		return this.http.post<OperationResult<FinancialMovementResult[]>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/confirming/payments/financialmovements/search')!,
			criteria
		);
	}

	public countFinancialMovements(criteria: FinancialMovementSearchCriteria): Observable<OperationResult<number>> {
		return this.http.post<OperationResult<number>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/confirming/payments/financialmovements/searchCount')!,
			criteria
		);
	}
}
